import { selectKillSessionReason } from '@reducks/session';
import { useSelector } from 'react-redux';
import { KILL_SESSION_REASONS } from '@config/index';

const REASONS_KEYS = Object.values(KILL_SESSION_REASONS);

export const useIsSessionActive = () => {
  const killSessionReason = useSelector(selectKillSessionReason);
  const hasExpiredSession = REASONS_KEYS.includes(killSessionReason);

  return { hasExpiredSession };
};
